import { combineReducers } from "redux";
import { templateDetailsState } from "./templateDetailsReducer";

export const templateDetailsReducers = combineReducers({
    templateDetailsState: templateDetailsState
});
